import {createApp} from 'vue'
import Store from 'store'
import ClientList from './ClientList'

const el = '.nlx-component--client-list'
const DOM = document.querySelector(el)

if(DOM){

    const tableData = JSON.parse(DOM.dataset.table)
    Store.dispatch('main/setClientListTableData', tableData)
    
    const component = createApp(ClientList).use(Store)
    component.mount(el)
}

